import withPreview from '../../hoc/WithPreview/WithPreview.js';
import tmpl from './NotFound.jsx';

const NotFound = () => tmpl();

export default withPreview(NotFound);
